import React from 'react'
import { FilterCategoryType, ColourFilters, RangeFilter, SeatTypeFilter, DimensionFilter } from '../../types/FiltersTypes'
import { FilterCategoryContent } from './FilterCategoryContent'
import { ColourCategoryContent } from './ColourCategoryContent'
import { DimensionFiltersContent } from './DimensionFiltersContent'

interface Props {
  category: FilterCategoryType
  filters: DimensionFilter[] | ColourFilters | RangeFilter[] | SeatTypeFilter[]
}

export const FilterCategory: React.FC<Props> = ({ category, filters }) => {
  if (category === 'colour') return <ColourCategoryContent />
  if (category === 'dimensions') return <DimensionFiltersContent dimensions={filters as DimensionFilter[]} />

  return <FilterCategoryContent category={category} />
}
